import type { FC, ReactNode } from 'react'

interface PageTitleProps {
  title: string
  leftButton?: ReactNode
  rightButton?: ReactNode
}

export const PageTitle: FC<PageTitleProps> = ({
  title,
  leftButton,
  rightButton
}) => {
  return (
    <div className="flex justify-between items-center h-[76px] bg-surface-white px-4 md:px-6 z-1">
      <div className="flex items-center gap-2">
        {leftButton}
        <span className="text-headline-s md:text-headline-m">{title}</span>
      </div>
      {rightButton}
    </div>
  )
}
